<template>
  <div style="display: inline-block">
    <el-form-item :label-width="labelWidth" :label="label" class="date-select" v-if="needForm" :prop="redStart">
      <div :style="{
      width: innerWidth.includes('%') ? innerWidth : innerWidth + 'px',
    }" class="i-block">
        <el-col :span="11" style="padding: 0px !important">
          <el-form-item class="start" :prop="startProp">
            <el-date-picker style="width: 100%" @change="startTimeChange" :size="size" v-model="startTime"
              type="datetime" :picker-options="{
      disabledDate: (time) => {
        return dataTime.startTimeData(time);
      },
      selectableRange: this.startTimeRange,
    }" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间"
              :disabled="disabled"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="2" style="text-align: center; padding: 0px">
          {{ center }}
        </el-col>
        <el-col :span="11" style="padding: 0px !important">
          <el-form-item class="end" :prop="endProp">
            <el-date-picker default-time="23:59:59" style="width: 100%" @change="endTimeChange" :size="size"
              v-model="endTime" type="datetime" :picker-options="{
      disabledDate: (time) => {
        return dataTime.endTimeData(time);
      },
      selectableRange: this.endTimeRange,
    }" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间"
              :disabled="disabled"></el-date-picker>
          </el-form-item>
        </el-col>
      </div>
    </el-form-item>

    <div v-else class="el-date-picker-wrap">
      <el-col :span="11" style="padding: 0px !important">
        <el-date-picker style="width: 100%" @change="startTimeChange" :size="size" v-model="startTime" type="datetime"
          :picker-options="{
      disabledDate: (time) => {
        return dataTime.startTimeData(time);
      },
      selectableRange: this.startTimeRange,
    }" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间"
          :disabled="disabled"></el-date-picker>
      </el-col>
      <el-col :span="2" style="text-align: center; padding: 0">
        {{ center }}
      </el-col>
      <el-col :span="11" style="padding: 0px !important">
        <el-date-picker default-time="23:59:59" style="width: 100%" @change="endTimeChange" :size="size"
          v-model="endTime" type="datetime" :picker-options="{
      disabledDate: (time) => {
        return dataTime.endTimeData(time);
      },
      selectableRange: this.endTimeRange,
    }" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间"
          :disabled="disabled"></el-date-picker>
      </el-col>
    </div>
  </div>
</template>

/* ps: 因为是单向数据绑定，所以重置的时侯还是需要清空 startDate and endDate
缺点：还是无法禁用秒的范围 */
<script>
import { isSameDay, compareDate } from "./index.js";
export default {
  name: "TimeDatePicker",
  props: {
    needForm: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: "",
    },
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
    size: {
      type: String,
      default: "large",
    },
    crossBarWidth: {
      type: String,
      default: "10",
    },
    center: {
      type: String,
      default: "-",
    },
    labelWidth: {
      type: String,
      default: "100px",
    },
    startProp: {
      type: String,
      default: "",
    },
    endProp: {
      type: String,
      default: "",
    },
    redStart: {
      type: String,
      default: "",
    },
    innerWidth: {
      type: [Number, String],
      default: 420,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    notChooseBeforeTodayTime: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      /*
      下面注释的是default-value的写法
      */
      // endDefaultValue: new Date(2023, 6, 27, 23, 59, 59),
      // endDefaultValue: new Date('2023-7-27 23:59:59'),
      endDefaultValue: "23:59:59",
      startTime: "",
      endTime: "",
      startTimeRange: null,
      endTimeRange: null,
      dataTime: {
        startTimeData: (time) => {
          if (this.endTime) {
            return time.getTime() > new Date(this.endTime).getTime();
          } else {
            return false;
          }
        },
        endTimeData: (time) => {
          if (this.notChooseBeforeTodayTime) {
            if (compareDate(new Date(), this.startTime) === "towBig") {
              return (
                time.getTime() <=
                new Date(this.startTime).getTime() - 3600 * 1000 * 24
              );
            } else {
              return time.getTime() < new Date(new Date().setHours(0, 0, 0, 0));
            }
          } else {
            if (this.startTime) {
              return (
                time.getTime() <=
                new Date(this.startTime).getTime() - 3600 * 1000 * 24
              );
            }
          }
        },
      },
    };
  },
  computed: {},
  watch: {
    startDate: {
      handler(newValue) {
        this.startTime = newValue;
      },
      immediate: true,
    },
    endDate: {
      handler(newValue) {
        this.endTime = newValue;
      },
      immediate: true,
    },
    startTime: {
      handler(newVal) {
        if (newVal && this.endTime && isSameDay(newVal, this.endTime)) {
          this.startTimeRange =
            "00:00:00 - " +
            this.getHourChange(this.endTime) +
            ":" +
            this.getMinutesChange(this.endTime) +
            ":" +
            this.getSecondChange(this.endTime);
        } else {
          this.startTimeRange = "00:00:00 - 23:59:59";
          if (this.notChooseBeforeTodayTime) {
            const data = new Date();
            this.endTimeRange =
              this.getHourChange(data) +
              ":" +
              this.getMinutesChange(data) +
              ":" +
              this.getSecondChange(data) +
              " - 23:59:59";
          } else {
            this.endTimeRange = "00:00:00 - 23:59:59";
          }
        }
        this.$emit("update:startDate", newVal);
      },
      deep: true,
    },
    endTime: {
      handler(newVal) {
        if (newVal && this.startTime && isSameDay(newVal, this.startTime)) {
          // 需要判断开始时间是否在当前时间之前，如果是取得是当前时间的范围
          const newDate = new Date();
          if (compareDate(newDate, this.startTime) === "towBig") {
            this.endTimeRange =
              this.getHourChange(this.startTime) +
              ":" +
              this.getMinutesChange(this.startTime) +
              ":" +
              this.getSecondChange(this.startTime) +
              " - 23:59:59";
          } else {
            this.endTimeRange =
              this.getHourChange(newDate) +
              ":" +
              this.getMinutesChange(newDate) +
              ":" +
              this.getSecondChange(newDate) +
              " - 23:59:59";
          }
        } else {
          if (this.notChooseBeforeTodayTime) {
            const data = new Date();
            this.endTimeRange =
              this.getHourChange(data) +
              ":" +
              this.getMinutesChange(data) +
              ":" +
              this.getSecondChange(data) +
              " - 23:59:59";
          } else {
            this.endTimeRange = "00:00:00 - 23:59:59";
          }
          this.startTimeRange = "00:00:00 - 23:59:59";
        }
        if (
          newVal &&
          newVal.substring(newVal.indexOf(" ") + 1) === "00:00:00"
        ) {
          const strTime = `${newVal.substring(0, 10)} 23:59:59`;
          this.$emit("update:endDate", strTime);
        } else {
          this.$emit("update:endDate", newVal);
        }
      },
      deep: true,
    },
  },
  methods: {
    startTimeChange(startTime) {
      // console.log('startTime', startTime)
    },
    endTimeChange(endTime) {
      // console.log('endTime', endTime)
    },
    // 获取单独的小时(24小时制)
    getHourChange(val) {
      let date = new Date(Date.parse(val));
      return date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    },
    // 获取单独的分钟
    getMinutesChange(val) {
      let date = new Date(Date.parse(val));
      return date.getMinutes() < 10
        ? "0" + date.getMinutes()
        : date.getMinutes();
    },
    // 获取单独的秒
    getSecondChange(val) {
      let date = new Date(Date.parse(val));
      return date.getSeconds() < 10
        ? "0" + date.getSeconds()
        : date.getSeconds();
    },
  },
};
</script>

<style scoped>
.date-wrap {
  width: 100%;
  display: flex;
  align-items: center;
}

.cross-bar {
  display: flex;
  justify-content: center;
  align-items: center;
}

.start.el-form-item,
.end.el-form-item {
  margin-right: 0px !important;
  width: 100% !important;
}

.el-date-picker-wrap {
  width: 100%;
  display: flex;
  align-items: center;
}

::v-deep .date-select .el-form-item__content {
  height: 40px !important;
}

::v-deep .start .el-form-item__content {
  width: 100% !important;
}

::v-deep .end .el-form-item__content {
  width: 100% !important;
}
</style>
